//Estados en InicioPage para FormA (registros)

export const REGISTROS_INICIAL = {
    id_partido_obra: "",
    id_obra: null,
    id_interno: null,
    nombre_obra: "",
    tipo_subsidio: "",
    fecha_carga: null,
    fecha_actualizacion: null,
    encargado_proyecto: "",
    organismo_solicitante: "", //ong
    organismo_otro:"", //12-MAY-25: cg_21_organismo_otro
    programa_lineamiento: "",
    modalidad: "",
    referente_politico: "",//REFERENTES por ahora se va 14-JUN-2025
    referente_politico_nombre: "", //28-abr-25: nuevo estado para el nombre //REFERENTES por ahora se va 14-JUN-2025
    contacto_proyecto: "",
    beneficiarios: "",
    monto_obra: null,
    fecha_imputacion: null,
    tipo_contratacion: "",
    plazo_obra: "",
    estado: "",
    descripcion_proyecto:"",
    lc_21_localidad: '',
    lc_22_identificacion_catastral: '',
    lc_22_1_datos_catastrales: '',
    lc_22_2_cuadro_calles: '',
    lc_23_observaciones_localizacion: '',
    lc_24_titular_dominio: '',
    partido: 0,
    partido_nombre: "",
    barrio_tipo: "",
    barrio_rppvap_nombre: null,
    barrio_otro_nombre: '',
    array_obras_expediente: [{
        expediente_o: "",
        objeto_o: "",
        fecha_caratulacion_o: null,
        descripcion_objeto_o: ""
    }],    
    area_responsable: "" // nuevo 11-jun-2025
};
//quitar de estado inicial
//array_tipo_subtipo_proyecto: [ { tipo: '', subtipo: '', cantidad: '', unidad: '', referencia: '' }],

//Estados en InicioPage para FormB 
// tramitacines internas
export const TRAMITACIONES_INTERNAS_INICIAL = {
    registracion_ong: "",
    resolucion_ong: "",
    documentacion_ong: "",
    informe_tecnico: "", //nuevo requisito 22-jul-2025
    modelo_convenio: "",        
    proyecto_resolucion: "",
    //desembolso: false,
    //desembolso_fecha: null,
    //'90_dias': false,
    //'90_dias_fecha': null,
    //----> agregar dos keys mas: una para el check de mail de contacto(por defecto false) y otra para el mail de contacto(por defecto "")
    //mail_contacto: false,
    //mail_contacto_correo: "",//no es fecha, es un input para ingredsar el correo
    //firma_convenio: false,
    //firma_convenio_fecha: null,
    //convenio_escaneado: "",    
    programa: "",//nuevo requisito 22-jul-2025
    resolucion: "",
    documentacion_pago_ok: "" 
};

// (tramitaciones externas)
export const TRAMITACIONES_EXTERNAS_INICIAL = [{
    exp: '',
    objeto: '',
    fecha_salida_convenio: null,
    fecha_firma_convenio: null,
    fecha_salida_reso: null,
    fecha_firma_reso: null
}];

//Estados para SelectedRequisitos
export const SELECTED_REQUISITOS_INICIAL = {
    nota_solicitud : false,
    informes_dominio: false,
    //registracion_ong: false, //paso a Internas
    designacion_intendente : false,
    anexo_social : false,
    anexo_tecnico : false,
    computo_y_presupuesto : false,
    planos_de_proyecto : false,
    prefactibilidad_es_de_servicio_s_suscripta_prestataria : false,
    constancia_de_cbu : false,
    acta_acuerdo : false,
    nota_regulacion_dominal : false,
    nota_certificacion_pago_arquitecto_mmdo : false,
    convenio_con_certificado : false,
    pago_a_certif : false,
    informe_final : false,
    listado_beneficiarios : false,
    pago_a_beneficiarios : false,
    anexo_fotografico : false,
    nota_solicitud_e2 : false,
    proyecto_e2 : false,
    nota_gastos_operativos : false,
    comprobante_microcredito : false,
    informe_rendiciones : false,
    ddjj : false,
    acuerdo_mutuo : false,
    nomina_beneficiarios : false,
    plan_financiamiento : false
};

//FormC //monto ----> es lo que se pagó
export const PAGO_MEJORAS_INICIAL = [
    { tipo_pago: "total", monto: '', fecha_pago: null, nro_instruccion: '', fecha_certificacion: null },
    { tipo_pago: "adenda", total_adenda: '', monto: '', fecha_pago: null, nro_instruccion: '', fecha_certificacion: null },
]

export const PAGO_MICROCREDITOS_INICIAL = [
    { tipo_pago: "total", monto: '', fecha_pago: null, nro_instruccion: '', fecha_certificacion: null },
    { tipo_pago: "adenda", total_adenda: '', monto: '', fecha_pago: null, nro_instruccion: '', fecha_certificacion: null },
]

export const PAGO_PROYECTOS_INICIAL = [
    { tipo_pago: "anticipo", monto: '', porc_pagado: '', fecha_pago: null, nro_instruccion: '', porc_avance_obra: '', fecha_certificacion: null },
    { tipo_pago: "2do_pago", monto: '', porc_pagado: '', fecha_pago: null, nro_instruccion: '', porc_avance_obra: '', fecha_certificacion: null },
    { tipo_pago: "3er_pago", monto: '', porc_pagado: '', fecha_pago: null, nro_instruccion: '', porc_avance_obra: '', fecha_certificacion: null },
    { tipo_pago: "adenda", total_adenda: '', monto: '', porc_pagado: '', fecha_pago: null, nro_instruccion: '', porc_avance_obra: '', fecha_certificacion: null },
]

